const PropTypes = require('prop-types');
const React = require('react');
const ReverbOrange = 'f6870f';

class SoundcloudEmbed extends React.Component {
  iframeSrc = () => {
    return `https://w.soundcloud.com/player/?${$.param(this.urlParams())}`;
  };

  urlParams = () => {
    return {
      url: this.props.url,
      auto_play: false,
      hide_related: true,
      show_comments: false,
      show_user: false,
      show_reposts: false,
      color: ReverbOrange,
    };
  };

  render() {
    return (
      <iframe
        width="100%"
        height={this.props.height}
        scrolling="no"
        frameBorder="no"
        src={this.iframeSrc()}
      />
    );
  }
}

SoundcloudEmbed.PropTypes = {
  url: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
};

module.exports = SoundcloudEmbed;



// WEBPACK FOOTER //
// ./javascripts/components/shared/soundcloud_embed.jsx